import { render, staticRenderFns } from "./supplier-reporting.vue?vue&type=template&id=4e94b68e&"
import script from "./supplier-reporting.vue?vue&type=script&lang=js&"
export * from "./supplier-reporting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports